/* eslint-disable functional/immutable-data */

import { ApplePayCheckout } from './components';

export const ApplePay = () => {
  return null;
};

ApplePay.Checkout = ApplePayCheckout;
